import * as React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import {
	AppShell,
	Drawer,
	Box,
	Toaster,
} from '@seeneco-ui/core';
import { Auth, AppSession } from '@seeneco-ui/business';

import { Routing, appPageRoutes } from '@routing';
import Sidebar from '../sibebar';
import { contextActionsPack } from '@shared/actions';
import { contextSelectorsPack } from '@shared/selectors';
const {
	GlobalStyle,
	Root,
	HeaderLayout,
	ContentLayout,
	SidebarLayout,
	RoutingLayout,
} = AppShell.Base;


const sidebarItems = appPageRoutes.filter(x => x.showInMenu);

type ShellProps = {
	isAuthorized: boolean;
	ticketUID: string;
	isLoadedContext: boolean;
	fetchSessionContext: (ticketUID: string) => void;
} & Partial<RouteComponentProps<any>>

const Shell: React.SFC<ShellProps> = (props) => {
	const {
		isLoadedContext,
		fetchSessionContext,
	} = props;
	const { isAuthorized, ticketUID } = Auth.useAuthContext();
	const canRender = isLoadedContext;

	React.useEffect(() => {
		isAuthorized && fetchSessionContext(ticketUID);
	}, [isAuthorized]);

	if (!isAuthorized) {
		return (
			<React.Fragment>
				<GlobalStyle />
				<Routing />
			</React.Fragment>
		);
	}

	return (
		<Root>
			<GlobalStyle />
			<HeaderLayout>
				<AppShell.Header>
					<Box paddingRight='20px'>
						<AppSession appearance='only-shell' />
					</Box>
				</AppShell.Header>
			</HeaderLayout>
			<ContentLayout>
				<SidebarLayout>
					<Sidebar items={sidebarItems} />
				</SidebarLayout>
				<RoutingLayout>
					{
						canRender &&
						<Routing />
					}
				</RoutingLayout>
			</ContentLayout>
			<Drawer.default.Base ref={Drawer.default.setRef} />
			<Toaster />
		</Root>
	);
}

function mapStateToProps(state) {
	return {
		isLoadedContext: contextSelectorsPack.selectAsyncSessionContext.selectIsLoaded(state)
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		fetchSessionContext: contextActionsPack.actions.fetchSessionContext,
	}, dispatch);
}

const enhance: Function = compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Shell);
